
import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        accessToken: null,
        refreshToken: null,
        roles: [],
        permissions: [],
        expiresAt: null,
    }),

    getters: {
        isAuthenticated: (state) =>
            Boolean(state.accessToken),

        isAdmin: (state) =>
            state.roles.includes('Admin'),
    },

    actions: {
        setSession(data) {
            this.accessToken = data.accessToken;
            this.refreshToken = data.refreshToken;
            this.roles = data.roles ?? [];
            this.permissions = data.permissions ?? [];
            this.expiresAt = data.expiresAt ?? null;

            // Zachowanie zgodności z obecnym rozwiązaniem.
            localStorage.setItem('authToken', data.accessToken);
            localStorage.setItem('refreshToken', data.refreshToken);
            localStorage.setItem('authRoles', JSON.stringify(this.roles));
            localStorage.setItem('authPermissions', JSON.stringify(this.permissions));
            localStorage.setItem('expiresAt', this.expiresAt ?? '');
        },

        hydrate() {
            this.accessToken = localStorage.getItem('authToken');
            this.refreshToken = localStorage.getItem('refreshToken');

            try {
                this.roles = JSON.parse(
                    localStorage.getItem('authRoles') ?? '[]'
                );
                this.permissions = JSON.parse(
                    localStorage.getItem('authPermissions') ?? '[]'
                );
            } catch {
                this.roles = [];
                this.permissions = [];
            }

            this.expiresAt = localStorage.getItem('expiresAt') || null;
        },

        hasRole(role) {
            return this.roles.includes(role);
        },

        hasPermission(permission) {
            return this.permissions.includes(permission);
        },

        clearSession() {
            this.$reset();

            for (const key of [
                'authToken',
                'refreshToken',
                'authRoles',
                'authPermissions',
                'expiresAt',
            ]) {
                localStorage.removeItem(key);
            }
        },
    },
});
